/**
 * Municipios de la Diócesis de Ipiales (Nariño) - 27 municipios.
 * Orden oficial para la pestaña "Por municipios" en Parroquias.
 */
export const MUNICIPIOS_DIOCESIS = [
  'Aldana',
  'Ancuya',
  'Cuaspud', // Carlosama
  'Contadero',
  'Córdoba',
  'Cumbal',
  'Cumbitara',
  'Guachucal',
  'Guaitarilla',
  'Gualmatán',
  'Iles',
  'Imués',
  'Ipiales',
  'La Llanada',
  'Linares',
  'Los Andes', // Sotomayor
  'Mallama',
  'Ospina',
  'Potosí',
  'Providencia',
  'Puerres',
  'Pupiales',
  'Ricaurte',
  'Samaniego',
  'Santacruz', // Guachavés
  'Sapuyes',
  'Túquerres',
];

/** Alternativas de nombre en ubicación -> nombre en lista (para normalizar) */
export const MUNICIPIO_ALIASES = {
  carlosama: 'Cuaspud',
  guachavés: 'Santacruz',
  guachaves: 'Santacruz',
  sotomayor: 'Los Andes',
  piedrancha: 'Mallama',
};

/**
 * Extrae el municipio normalizado desde p.ubicacion para agrupar.
 * Ej: "B. Centenario - Ipiales" -> "Ipiales", "Carlosama" -> "Cuaspud"
 */
export function municipioDesdeUbicacion(ubicacion) {
  if (!ubicacion || !String(ubicacion).trim()) return null;
  const u = String(ubicacion).trim();
  const parte = u.includes(' - ') ? u.split(' - ').pop().trim() : u;
  const parteLower = parte.toLowerCase();
  const alias = MUNICIPIO_ALIASES[parteLower];
  if (alias) return alias;
  const exacto = MUNICIPIOS_DIOCESIS.find(m => m.toLowerCase() === parteLower);
  if (exacto) return exacto;
  const contiene = MUNICIPIOS_DIOCESIS.find(m => parteLower.includes(m.toLowerCase()) || m.toLowerCase().includes(parteLower));
  return contiene || null;
}
